import styles from "./styles/service-page-header.module.scss";
import React from "react";

interface ServicePageTitleProps {
  title: React.ReactNode;
  description?: string;
}

const ServicePageHeader = ({ title, description }: ServicePageTitleProps) => {
  return (
    <div className={styles.page_titles}>
      <h1>{title}</h1>
      <h2>{description}</h2>
    </div>
  );
};

export default ServicePageHeader;
